module.exports = __webpack_public_path__ + "static/media/img_setup.d89c857f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/img_setup.svg
// module id = 1082
// module chunks = 0